import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import cx from 'clsx';

import { FeedArticle } from '@/views/Stream/types';
import { formatNum } from '@/utils/math';
import { useCurrentAddressInfo } from '@/hooks/address';

import styles from './index.module.scss';
import { NavLink } from 'react-router-dom';

const RankingExtraXPTable = [
  [10, '100%'],
  [100, '60%'],
  [1000, '40%'],
  [10000, '20%'],
] as const;

const Web3IdShare = '30%';

export const ExtraXP = ({ article }: { article: FeedArticle }) => {
  const { t } = useTranslation();
  const { userInfo } = useCurrentAddressInfo();

  if (!article) {
    return null;
  }

  const hasWeb3Id = !!userInfo?.desc?.user.web3_id;
  const rankingExtraXP =
    userInfo?.rank_at && RankingExtraXPTable.find(x => userInfo.rank_at <= x[0]);

  return (
    <div className={styles.container}>
      <div className={cx(styles.item, !hasWeb3Id && styles.inactive)}>
        {hasWeb3Id ? (
          <Trans i18nKey="ExtraXP.dd0rd" values={{ share: Web3IdShare }}>
            You hold a <span className={styles.bold}>Web3 ID</span> and will receive an additional
            <span className={styles.xpShare}>30% XP</span> for completing actions.
          </Trans>
        ) : (
          <>
            {t('ExtraXP.1ua5q88', { share: Web3IdShare })}{' '}
            <NavLink to="/settings" className={styles.mintLink}>
              {t('ExtraXP.1dr4qig')}
            </NavLink>
          </>
        )}
      </div>
      <div className={cx(styles.item, !rankingExtraXP && styles.inactive)}>
        {rankingExtraXP ? (
          <Trans
            i18nKey="ExtraXP.pt9qkq"
            values={{ rank: formatNum(rankingExtraXP?.[0]), share: rankingExtraXP?.[1] }}>
            you're in the <span className={styles.bold}>top xx of Web3 Social Ranking</span> and
            will receive an additional <span className={styles.xpShare}>xx% XP</span> for completing
            actions.
          </Trans>
        ) : (
          <>
            {t('ExtraXP.1xu2mfk', {
              maxRank: formatNum(RankingExtraXPTable[RankingExtraXPTable.length - 1][0]),
            })}
          </>
        )}
      </div>
    </div>
  );
};
